import classNames from 'classnames';
import * as React from 'react';
import { Href } from 'redux-little-router';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { RouteStyledLink } from '../StyledLink/StyledLink';

import './GridParentCell.css';

export interface Props {
    campaign: {
        id: string;
        name: string;
        campaignUrl: Href;
    };
    group?: {
        id: string;
        name: string;
        groupUrl: Href;
    };
}

export class GridParentCell extends React.PureComponent<Props> {
    render() {
        const {
            campaign: { id: campaignId, name: campaignName, campaignUrl }
        } = this.props;
        const title = `${campaignName}, № ${campaignId}`;

        return (
            <div className={Bem.cls('grid-parent-cell')}>
                <div className={Bem.cls('grid-parent-cell', 'campaign-row')} title={title}>
                    <RouteStyledLink
                        href={campaignUrl}
                        title={campaignName}
                        cls={Bem.cls('grid-parent-cell', 'campaign-name')}
                    >
                        {campaignName}
                    </RouteStyledLink>
                    {', '}
                    <div
                        className={classNames(
                            Bem.cls('grid-parent-cell', 'campaign-id'),
                            TestBem.cls('grid-parent-cell', 'campaign-id')
                        )}
                    >
                        № {campaignId}
                    </div>
                </div>
                {this.getGroupContent()}
            </div>
        );
    }

    getGroupContent = () => {
        const { group } = this.props;

        if (group) {
            const { id: groupId, name: groupName, groupUrl } = group;

            return (
                <div className={Bem.cls('grid-parent-cell', 'group-row')} title={`${groupName}, № ${groupId}`}>
                    <RouteStyledLink href={groupUrl} title={groupName} cls={Bem.cls('grid-parent-cell', 'group-name')}>
                        {groupName}
                    </RouteStyledLink>
                    {', '}
                    <div
                        className={classNames(
                            Bem.cls('grid-parent-cell', 'group-id'),
                            TestBem.cls('grid-parent-cell', 'group-id')
                        )}
                    >
                        № {groupId}
                    </div>
                </div>
            );
        }

        return '';
    };
}
